'use client';

import { FC, useRef } from 'react';
import Link from 'next/link';
import Image from 'next/image';

import dayjs from 'dayjs';

import { Button } from '../ui/button';
import { BlogRecentQuery } from '../../generated/operations';
import { useIsVisible } from '../../hooks/useIsVisible';

interface IBlogPosts {
  blogData: BlogRecentQuery;
  showBlogLink?: boolean;
}

export const BlogPosts: FC<IBlogPosts> = (props) => {
  const { blogData, showBlogLink } = props;

  const titleRef = useRef<HTMLHeadingElement>(null);
  const isVisibleTitle = useIsVisible(titleRef);

  const blogPostsRef = useRef<HTMLDivElement>(null);
  const isVisibleBlogPosts = useIsVisible(blogPostsRef);

  return (
    <div className="p-10 sm-1/2:p-5 w-full">
      <div className="container">
        <div className="flex justify-between items-center">
          <h1
            ref={titleRef}
            className={`mb-10 font-poppins text-dark-blue font-semibold text-[40px]/[150%] duration-1000 transition-all ${isVisibleTitle ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-full'}`}
          >
            Latest news
          </h1>
          {showBlogLink && (
            <p className="text-gray-text">Connected blog: {blogData.blogUrl}</p>
          )}
        </div>

        <div ref={blogPostsRef}>
          <div className={`grid grid-cols-12 gap-6 mb-[60px] duration-1000 transition-all ${isVisibleBlogPosts ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-full'}`}>
            {blogData?.blogRecent?.map((post, index) => (
              <Link href={post.fullUrl} passHref key={index} legacyBehavior>
                <a target="_blank" className="col-span-3 md:col-span-4 sm:col-span-6 sm-1/2:col-span-12 group">
                  <div className="rounded-2xl p-4 border border-[#E1E3E4] h-full">
                    <div className="h-[180px] w-full rounded-lg overflow-hidden mb-3">
                      {post.image && (
                        <Image
                          width={200}
                          height={200}
                          alt={post.title}
                          className="object-contain w-full h-full group-hover:scale-110 transition-transform duration-300"
                          src={post.image as string}
                        />
                      )}
                    </div>
                    <div className="flex justify-end mb-4">
                      <p className="text-[12px]/[150%] text-gray-text">{dayjs(post.createdAt).format('DD MMMM YYYY')}</p>
                    </div>
                    <p className="text-dark-blue text-[16px]/[150%] font-semibold">{post.title}</p>
                  </div>
                </a>
              </Link>
            ))}
          </div>
        </div>
        <Button variant="primary" className="mx-auto flex" onClick={() => window.open(blogData?.blogUrl ?? '', '_blank')}>
          Open more
        </Button>
      </div>
    </div>
  );
}
